import React from 'react';

import { ComposerFragment, ProviderReducer } from './components';
import { providers } from './providers';

/**
 * @Component
 * @name ProviderComposer
 * @description Component that receives a list of providers and composes them to a single component.
 */
export const ProviderComposer: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const ComposedProviders = [...providers].reduce(ProviderReducer, ComposerFragment);

  return <ComposedProviders>{children}</ComposedProviders>;
};
